import React, { useState } from "react";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { SelectBox } from "devextreme-react";
import Button from "../../../components/Button";
import * as XLSX from "xlsx";

const TemplateGenerator = ({
  section,
  yearsSource,
  year,
  setYear,
  handleGenerateTemplate,
  handleUpload,
  isGenerating,
  isUploading,
}) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleConfirmUpload = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        handleUpload(jsonData);
      };
      reader.readAsArrayBuffer(file);
    }
    setOpen(false);
  };

  return (
    <div className="template-generator">
      <div
        className="template-generator__controls"
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
        {section === "counseling" && (
          <div
            style={{
              width: "75rem",
            }}
          >
            <SelectBox
              dataSource={yearsSource}
              placeholder="Select year"
              itemRender={(data) => <p>{data}</p>}
              required={true}
              value={year}
              onValueChanged={(e) => setYear(e.value)}
            />
          </div>
        )}

        <Button onClick={handleGenerateTemplate} primary>
          {isGenerating ? (
            <CircularProgress size="1.5em" color="secondary" />
          ) : (
            "Template"
          )}
        </Button>

        <Button onClick={handleClickOpen} primary>
          {isUploading ? (
            <CircularProgress size="1.5em" color="secondary" />
          ) : (
            "Upload"
          )}
        </Button>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{"Confirm Upload"}</DialogTitle>
          <input
            style={{
              marginLeft: "12rem",
            }}
            type="file"
            onChange={handleFileChange}
          />
      
          <DialogContent style={{display: "flex", alignContent: "center"}}>
            <DialogContentText style={{textAlign: "center"}}>
              Are you sure you want to upload the file?<br /> If you upload this file, 
              all of the counseling´s message of the chosen year will be updated.
            </DialogContentText>
          </DialogContent>
          
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmUpload} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default TemplateGenerator;